import { ButtonHTMLAttributes, ReactNode } from "react"
import { classNames } from "../../utils/helpers"

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>  {
  children: ReactNode
  /** Use it to overwrite the default container styles, you may need to make some styles !important */
  className?: string
}

const Button = ({ children, className, ...rest }: ButtonProps) => {
  const toBecomeVariants =
    "whitespace-nowrap fluid-base font-bold w-full rounded-3xl py-4 px-4 sm:px-8"
  return (
    <button className={classNames(toBecomeVariants, className)} {...rest}>
      {children}
    </button>
  )
}

export default Button
